<template>
  <div class="filter-app">
    <section class="section-wrapper filters">
      <div class="content-wrapper">
        <FiltersSection
          :APICall="APICall"
          :applyFiltersText="applyFiltersText"
          :applyFiltersToAPICall="applyFiltersToAPICall"
          :clearAllFilters="clearAllFilters"
          :clearFiltersText="clearFiltersText"
          :culturalExperience="culturalExperience"
          :deleteSubRegions="deleteSubRegions"
          :disableSubRegionDropdown="disableSubRegionDropdown"
          :enableSupplierFocusedSearch="enableSupplierFocusedSearch"
          :genders="genders"
          :locations="locations"
          :languages="languages"
          :optionalExpanded="optionalExpanded"
          :removeFilterFromButton="removeFilterFromButton"
          :selectedCulturalExperience="selectedCulturalExperience"
          :selectedGenders="selectedGenders"
          :selectedLanguages="selectedLanguages"
          :selectedRegion="selectedRegion"
          :selectedSubRegions="selectedSubRegions"
          :selectedTherapistExperience="selectedTherapistExperience"
          :subRegionsForRegion="subRegionsForRegion"
          :therapistExperience="therapistExperience"
          :updateFilterFromButton="updateFilterFromButton"
          :updateRegion="updateRegion"
          :updateShowOptions="updateShowOptions"
          :updateSubRegions="updateSubRegions"
        ></FiltersSection>
      </div>
    </section>
    <div v-if="enableSupplierFocusedSearch">
      <div class="filters-results">
        <section class="results-section-wrapper">
          <div class="content-wrapper results">
            <ResultsSection
              :APICall="APICall"
              :loading="loading"
              :isTab2="true"
              :message="message"
              :messageType="messageType"
              :noResultsText="noResultsText"
              :providerCount="filterSearchResponse.providerCount"
              :providers="filterSearchResponse"
              :resultsCurrentPage="filterSearchResponse.page"
              :resultsExplainerText="resultsExplainerText"
              :resultsTotalPages="filterSearchResponse.pageCount"
              :showNoResultsText="showNoResultsText"
              :showResultsCountText="showResultsCountText"
              :supplierCount="filterSearchResponse.supplierCount"
              :suppliers="filterSearchResponse.suppliers"
            ></ResultsSection>
          </div>
        </section>
      </div>
    </div>
    <div v-else>
      <Tabs :enableSupplierFocusedSearch="enableSupplierFocusedSearch">
        <Tab
          :enableSupplierFocusedSearch="enableSupplierFocusedSearch"
          :name="resultsTab1Text"
          :isTab2="false"
          selected="true"
        >
          <div class="tab">
            <div class="filters-results">
              <section class="results-section-wrapper">
                <div class="content-wrapper results">
                  <ResultsSection
                    :APICall="APICall"
                    :isTab2="false"
                    :loading="loading"
                    :message="message"
                    :messageType="messageType"
                    :noResultsText="noResultsText"
                    :pagination="pagination"
                    :providerCount="filterSearchResponse.providerCount"
                    :providers="filterSearchResponse"
                    :resultsCurrentPage="filterSearchResponse.page"
                    :resultsExplainerText="resultsExplainerText"
                    :resultsTotalPages="filterSearchResponse.pageCount"
                    :showNoResultsText="showNoResultsText"
                    :showResultsCountText="showResultsCountText"
                    :suppliers="filterSearchResponse.suppliers"
                  ></ResultsSection>
                </div>
              </section>
            </div>
          </div>
        </Tab>
        <Tab
          :enableSupplierFocusedSearch="enableSupplierFocusedSearch"
          :name="resultsTab2Text"
          :isTab2="true"
        >
          <div class="tab">
            <div class="filters-results">
              <section class="results-section-wrapper">
                <div class="content-wrapper results">
                  <ResultsSection
                    :APICall="APICall"
                    :loading="loading"
                    :isTab2="true"
                    :message="message"
                    :messageType="messageType"
                    :noResultsText="noResultsText"
                    :providerCount="filterSearchResponse.providerCount"
                    :providers="filterSearchResponse"
                    :resultsCurrentPage="filterSearchResponse.page"
                    :resultsExplainerText="resultsExplainerText"
                    :resultsTotalPages="filterSearchResponse.pageCount"
                    :showNoResultsText="showNoResultsText"
                    :showResultsCountText="showResultsCountText"
                    :supplierCount="filterSearchResponse.supplierCount"
                    :suppliers="filterSearchResponse.suppliers"
                  ></ResultsSection>
                </div>
              </section>
            </div>
          </div>
        </Tab>
      </Tabs>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import FiltersSection from "./components/FiltersSection.vue";
import ResultsSection from "./components/ResultsSection.vue";
import Tab from "./components/Tab.vue";
import Tabs from "./components/Tabs.vue";

export default Vue.component("FilterApp", {
  props: {
    APICall: Function,
    applyFiltersText: String,
    applyFiltersToAPICall: Function,
    clearAllFilters: Function,
    clearFiltersText: String,
    culturalExperience: Array,
    deleteSubRegions: Function,
    disableSubRegionDropdown: Boolean,
    enableSupplierFocusedSearch: Boolean,
    filterSearchResponse: Object,
    genders: Array,
    isTab2: Boolean,
    languages: Array,
    loading: Boolean,
    locations: Array,
    message: String,
    messageType: String,
    noResultsPlaceholderText: String,
    noResultsText: String,
    optionalExpanded: Boolean,
    pagination: Array,
    paginationShowNext: Boolean,
    removeFilterFromButton: Function,
    resultsExplainerText: String,
    resultsTab1Text: String,
    resultsTab2Text: String,
    selectedRegion: Array,
    selectedCulturalExperience: Array,
    selectedGenders: Array,
    selectedLanguages: Array,
    selectedSubRegions: Array,
    selectedTherapistExperience: Array,
    showNoResultsText: Boolean,
    showResultsCountText: Boolean,
    subRegionsForRegion: Array,
    therapistExperience: Array,
    updateFilterFromButton: Function,
    updateRegion: Function,
    updateSubRegions: Function,
    updateShowOptions: Function,
  },
  components: {
    FiltersSection,
    ResultsSection,
    Tab,
    Tabs,
  },
});
</script>
